import React from 'react';
import {render} from 'react-dom';
import {Router, Route, browserHistory, IndexRoute} from 'react-router'
import {syncHistoryWithStore, routerMiddleware} from 'react-router-redux'
import {Provider} from 'react-redux';
import {createStore, applyMiddleware, compose} from 'redux';
import thunk from 'redux-thunk';
import reducers from './reducers';
import App from './components/App';
import {initializeApp} from 'firebase';
import auth from 'firebase/auth';
import {loginFirebaseUser, getETMSUser, loading, retrieveGroup} from './actions';
import _ from 'lodash'
import {live} from './constants'
//import {showAlert} from './actions/index'

//Public
import Landing from './components/Landing';
import HomeContainer from './containers/HomeContainer';
import SupportContainer from './containers/SupportContainer'
//Logged In
import AccountContainer from './containers/AccountContainer';
import DashboardContainer from './containers/DashboardContainer';
import AdminContainer from './containers/AdminContainer'

import {hasLocalStorageUser} from './auth';
//import {removeLocalStorageUser} from './auth';
//removeLocalStorageUser() // to clear existing messed up local storage

import './index.css'
import Report from "./components/Report";

const routingMiddleware = routerMiddleware(browserHistory)

const config = live ? {
    apiKey: "AIzaSyDbEzov6A3Tl__XZ_FTdnorLTZgmZ_klXg",
    authDomain: "etms-beab3.firebaseapp.com",
    databaseURL: "https://etms-beab3.firebaseio.com",
    projectId: "etms-beab3",
    storageBucket: "etms-beab3.appspot.com",
    messagingSenderId: "208285428816"
} : {
    apiKey: "AIzaSyARMAzGhDU5jAmXXSiKixRFp7jNwuuBYss",
    authDomain: "etms-test.firebaseapp.com",
    databaseURL: "https://etms-test.firebaseio.com",
    projectId: "etms-test",
    storageBucket: "etms-test.appspot.com",
    messagingSenderId: "836770901844"
};
initializeApp(config);

const store = createStore(
    reducers,
    compose(
        applyMiddleware(thunk, routingMiddleware),
        window.devToolsExtension ? window.devToolsExtension() : f => f
    )
);

const history = syncHistoryWithStore(browserHistory, store);

//let adminIsCreatingAnotherUser = false
// export function setAdminIsCreatingAnotherUser(val) {
//     adminIsCreatingAnotherUser = val;
// }

//support for ms browsers
const startsWith = (str, searchString, position) => {
  position = position || 0;
  return str.substr(position, searchString.length) === searchString;
};

auth().onAuthStateChanged((user) => {
	console.log('onAuthStateChanged', user)

    //const isIE = !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g);
    if (user && !user.apiKey && user.j) {
        //console.log('user.j', user.j)
        user.apiKey = user.j
        const key = `firebase:authUser:${user.j}:[DEFAULT]`
        localStorage.setItem(key, typeof user === 'object' ? JSON.stringify(user) : user)
    }

    //if (adminIsCreatingAnotherUser) {
    //    return
    //}


    if (user) {
        console.log('trying to get firebase user', user)
        store.dispatch(loading(true));
        store.dispatch(loginFirebaseUser(user));
        store.dispatch(getETMSUser());
        store.dispatch(retrieveGroup());

        const validRoutePrefixes = ["/account", "/dashboard",  "/admin", "/report"]
        //console.log('currentLoc', browserHistory.getCurrentLocation(), validRoutePrefixes.filter(r => startsWith(browserHistory.getCurrentLocation().pathname.toLowerCase(), r)))
        if (!_.first(validRoutePrefixes.filter(r => startsWith(browserHistory.getCurrentLocation().pathname.toLowerCase(), r)))) {
            browserHistory.push('/dashboard');
        }
    } else {
        //firebaseListener();
        console.log("There is no current firebase user...");
    }
});

document.addEventListener('DOMContentLoaded', () => {
    //console.log('DOMContentLoaded')
	
    function requireAuth(nextState, replace) {
		//console.log('requireAuth nextstate', nextState, 'replace', replace, 'hasLocalStorageUser', hasLocalStorageUser())
        if (!hasLocalStorageUser()) {
			console.log('no local storage user, pushing login')
            replace({
                pathname: '/login',
                state: { nextPathname: nextState.location.pathname }
            })
        }
    }

    render(
        <Provider store={store}>
            <Router history={history}>
                <Route path="/" component={App}>
                    <IndexRoute component={HomeContainer}/>
                    <Route path="/account" component={AccountContainer} onEnter={requireAuth}/>
                    <Route path="/dashboard(/tests/:testId)" component={DashboardContainer} onEnter={requireAuth}/>
                    <Route path={"/report"} component={Report} onEnter={requireAuth}/>
                    <Route path="/admin(/:groupId)" component={AdminContainer} onEnter={requireAuth}/>

                </Route>
                {/*<Route path="/login(/:sub)" component={() => (<Landing passwordReset={false}/>)}/>  example of optional sub route  */}
                <Route path="/login" component={() => (<Landing passwordReset={false}/>)}/>

                <Route path="/passwordReset" component={() => (<Landing passwordReset={true}/>)}/>
                <Route path="/support" component={SupportContainer}/>
            </Router>
        </Provider>, document.getElementById('root'))
})



// WEBPACK FOOTER //
// ./src/index.js